<template>
  <div>
    <page-header :title="$t('Integrations')"></page-header>
        <div class="flex overflow-x-auto mt-4" style="scrollbar-width: none; -ms-overflow-style: none;">
      <div v-for="(tab, index) in tabs" :key="index" class="sm:w-auto w-1/2">
        <p @click="changeTab(tab.value)" :class="`font-medium whitespace-nowrap text-center md:text-[18px] text-[16px] sm:py-[11px] xl:px-[75px] lg:px-[50px] md:px-[25px] px-[17px] p-3 rounded-t-[5px] cursor-pointer leading-[22px] ${tab.value === $route.query.tab ? 'text-primary border-0 border-b-2 border-solid border-primary bg-carte-blanche' : 'border-0 border-b border-solid border-steam text-industrial-revolution'}`">
          {{ $t(tab.name) }}
        </p>
      </div>
    </div>
    <EcommerceStoreIntegrations v-if="activeTab === 'api-key'" :merchantStatus="merchantStatus" @APIKey="APIKey = $event" />
    <div v-if="activeTab === 'webhooks'" class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
      <webhook-events v-if="showEvents"/>
      <user-webhooks :merchantStatus="merchantStatus" v-else @showEvents="showEvents = $event"/>
    </div>
  </div>
</template>

<script>
import MerchantApiKeys from '../pages/user-settings/MerchantAPIKeys.vue'
import UserWebhooks from '../pages/user-settings/webhooks/UserWebhooks.vue'
import WebhookEvents from '../pages/user-settings/webhooks/WebhookEvents.vue'
import common from '../../assets/utils/common'
import EcommerceStoreIntegrations from './integrations/EcommerceStoreIntegrations.vue'

export default {
  data () {
    return {
      APIKey: '',
      activeTab: '',
      showEvents: false,
      merchantStatus: '',
      tabs: [
        {
          name: 'API Key',
          value: 'api-key'
        },
        {
          name: 'Webhooks',
          value: 'webhooks'
        }
      ],
      routeQuery: {}
    }
  },
  watch: {
    'showEvents' (val) {
      if (val === false) {
        this.$router.push({
          query: {
            tab: this.activeTab,
            webhookID: this.$route.query.webhookID,
            page: 1
          }
        }).catch(() => {})
      } else {
        this.$router.push({
          query: {
            tab: this.activeTab,
            filter: this.$route.query.filter,
            webhookID: this.$route.query.webhookID,
            page: 1
          }
        }).catch(() => {})
      }
    },
    '$route.query.filter' () {
      if (this.$route.query.filter === undefined) {
        this.showEvents = false
      } else {
        this.showEvents = true
      }
    },
    '$route.query.page' () {
      this.$router.push({
        query: {
          tab: this.activeTab,
          filter: this.$route.query.filter,
          webhookID: this.$route.query.webhookID,
          page: this.$route.query.page ? this.$route.query.page : 1
        }
      }).catch(() => {})
    },
    '$route.query.tab' (val) {
      this.changeTab(val)
      this.activeTab = val
    }
  },
  methods: {
    changeTab (tab) {
      this.activeTab = tab
      const query = { ...this.routeQuery, tab: this.activeTab, page: 1 }
      this.$router.push({ query: {...query} }).catch(() => {})
    }
  },
  computed: {
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    }
  },
  components: {
    MerchantApiKeys,
    UserWebhooks,
    WebhookEvents,
    EcommerceStoreIntegrations
  },
  created () {
    this.offset = (this.currentPage - 1) * this.maximumItems
    this.activeTab = this.$route.query.tab
    this.$router.push({
      name: this.$route.name, 
      params: { lang: this.$route.params.lang },
      query: {
        tab: 'api-key'
      }
    }).catch(() => {})
    const merchantData = common.checkMerchantInLocalStorage(this)
    let user = {}
    merchantData.then(results => {
      user = results.merchantData
      this.merchantStatus = user.status
    })
  }
}
</script>